/** Delay between sibling cards (team portraits, how-it-works steps). */
export const LANDING_ITEM_REVEAL_STAGGER_S = 0.15;

export function landingItemRevealDelay(index: number): number {
  return index * LANDING_ITEM_REVEAL_STAGGER_S;
}
